module.exports = __webpack_public_path__ + "static/img/img-jctf.d86b34e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-jctf.png
// module id = 437
// module chunks = 2